<template lang="pug">
  .review-list-item(:id="review.id")
    .review-list-item-content
      .reviewer {{ reviewerName(review.monthOfReview) }}
      rating-star(:rating="review.coachRateAverage")
      .comment(v-if="review.comment") {{ review.comment }}
    .separator
</template>

<style lang="scss" scoped>
.review-list-item {
  margin: 0 8px;
  .review-list-item-content {
    display: flex;
    flex-direction: column;
    padding: 16px 8px;
    @extend %body-text;
  }
  .reviewer,
  .rating-star {
    margin-bottom: 8px;
  }
}
</style>

<script>
import RatingStar from '@/components/atoms/RatingStar'
import Formatter from '@/components/mixins/Formatter'

export default {
  components: {
    RatingStar,
  },
  mixins: [Formatter],
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  methods: {
    reviewerName(monthOfReview) {
      return `${this.dateFormat(monthOfReview, 'Y年M月')}受講生`
    },
  },
}
</script>

<style lang="scss" scoped>
.comment {
  word-break: break-all;
  white-space: pre-line;
}
</style>
